module.exports = __webpack_public_path__ + "static/media/calendar-exclamation.ed5dfde1.svg";